// extracted by mini-css-extract-plugin
export default {"detailed-support-table-row__action-cell":"DetailedSupportTableRow_detailed-support-table-row__action-cell__kNR7g"};